import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { selectSubCompany } from './subCompany.selectors';

export const getSubCompanyLicensedStates = createSelector(
  selectSubCompany,
  ({ licensedStates }) => {
    if (Object.entries(licensedStates).length === 0) {
      return licensedStates;
    }

    return Object.entries(licensedStates).reduce(
      (acc, [key, license]) => ({
        ...acc,
        [key]: {
          id: license.id,
          stateCode: license.state.abbreviation,
          stateLicenseNumber: license.licenseNumber,
          licenseStartDate: license.terms.startDate,
          licenseExpireDate: license.terms.expirationDate,
          isRetailAllowed: license.isRetailAllowed,
          isWholesaleAllowed: license.isWholesaleAllowed,
          isNoQualifiedMortgageAllowed: license.isNoQualifiedMortgageAllowed,
          licenseType: license.licenseType,
        },
      }),
      {},
    );
  },
);

const getSubCompanyLicensedStatesValues = createSelector(
  getSubCompanyLicensedStates,
  Object.values,
);

export const getFilteredSubCompanyLicensedStates = createSelector(
  getDebouncedSearchValue,
  getSubCompanyLicensedStatesValues,
  searchItems(license => [license.stateCode]),
);
